import { Bell } from "lucide-react"

import { define, prop } from "../utils"
import { useModuleMetadata } from "../utils/tailwindConfig/hooks"

import BasePreview from "./base"

function PushProviderPreview({ ...props }) {
  useModuleMetadata('session', true)

  return <BasePreview {...props}>
    <div className="h-10"></div>
  </BasePreview>
}

function PushProviderHTML({ attributeKey }) {
  return <>
    {`{{{@session.meta.allocation_custom.${attributeKey || 'push-provider'}}}}`}
  </>
}

export default define('push-provider', PushProviderPreview, PushProviderHTML)
  .palete(<Bell size={20} />, 'Push Provider', 'Advanced')
  .property(prop.text('Attribute Key', 'attributeKey').category('default').ignoreDevice(true))
  .build()
